/* eslint-disable max-len */
export default {
    atol: {
        title: 'Atol',
        changeStatusColumns: ['Order number', 'Type of operation'],
        changeStatusButton: 'Send',
        viewBill: 'Viewing receipts',
        view: 'View',
        link: 'link',
        waitStatus: 'Waiting...',
        refundNumberSAP: 'Номер возврата SAP',

        list: {
            type: 'Type receipt',
            total: 'Sum, RUB',
            date: 'Date',
            link: 'Link',
        },
    },

    setKit: {
        title: 'SetKit',
        count: 'Found {count} check | Found {count} checks | Found {count} checks',
        view: 'View',
        empty: 'No checks found for order {orderId}!',
        addFch: {
            title: 'Add actual check',
            button: 'Add actual check',
            listTitle: 'List of actual checks',
            searchPlaceholder: 'Search by order number',
            orderId: 'Order number',
            guid: 'Check number',
            dateCreated: 'Check date',
            orderNotFound: 'Order not found',
            modal: {
                title: 'Order №{orderId}',
                templatesPlaceholder: 'Receipt templates',
                templatePoints: 'Points deduction',
                templatePromocode: 'Promo code applied',
                addProduct: '+ Add product',
                uploadFch: 'Upload receipt',
                uploadSuccess: 'Receipt uploaded successfully',
                errorInvalidData: 'Invalid request data',
                errorAlreadyExists: 'Receipt already exists for this order',
                errorEmptyBody: 'Request body is empty',
            },
        },
    },

    mailing: {
        add: {
            title: 'Add recipient',
            warning: ['Email is not filled in', 'Such a recipient already exists'],
            placeholder: 'Enter email',
            button: 'Add',
        },

        'delete': 'Are you sure you want to delete the recipient of mailings?',

        index: {
            title: 'Recipients',
            message: 'Could not get the mailing list',
        },

        typeList: {
            title: "Recipient's mailing lists",
            messages: [
                'Could not get the mailing list',
                'The mailing list could not be changed',
            ],
        },
    },

    roles: {
        main: {
            orderStatuses: {
                title: 'Setting up Order List Sections',
                lead:
                    'Orders with what statuses will be located in the sections of the list of orders, depending on the role of the user',
            },
            permissions: {
                title: 'Accesses',
                lead: 'Viewing accesses for roles',
            },
        },

        orderStatus: {
            button: 'Save changes',
            sections: ['Unused', 'In work', 'Completed', 'New'],
            message: "Couldn't get links between sections and order statuses",
        },

        roleButton: 'Failed to get a list of roles',
    },

    sap: {
        hold: {
            columns: ['Order number', 'Date', 'Type'],
            button: 'Send',
            alert: 'When unholding, the posting date must be equal to the holding posting date',
        },

        index: ['Transactions', 'Holding'],

        sendWiring: 'Отправить проводку',
        bulkSending: 'Массовая отправка',

        loader: {
            title: 'Загрузить файл',
            subtitle: 'Массовая отправка проводок в SAP на основе данных из файла',
            fileNotSelected: 'Файл не выбран',
            chooseFile: 'Выберите файл',
            downloadTemplate: 'Скачать шаблон {link} для заполнения',
            xlsxFile: '.xlsx-файла',
            invalidFileType: 'Недопустимый тип файла',
        },

        list: {
            title: 'Задания на массовую отправку проводок',
            empty: 'Нет актуальных заданий на массовую отправку проводок',
            id: 'ID',
            numberOfLines: 'Кол-во строк',
            initiator: 'Инициатор',
            dateOfCreation: 'Дата создания',
            dateOfUpdate: 'Дата обновления',
            status: 'Статус',
            inProgress: 'В обработке',
            error: 'Ошибка',
            done: 'Выполнено',
        },

        taskDetails: {
            id: 'ID',
            status: 'Статус',
            orderId: 'Номер заказа',
            date: 'Дата проводки',
            type: 'Вид проводки',
            message: 'Детали',
            back: 'Назад',
        },

        transaction: {
            columns: [
                'Order number',
                'Date',
                'Type of operation',
                'Event type',
                'Reverse Posting',
            ],
            button: 'Send',
            warehouse: 'Склад',
            factory: 'Завод',
            hintRequiredField: 'Обязательное поле, длина от 3 до 4 символов',
        },
    },

    reports: {
        typeReports: 'Report Type',
        selectPeriod: 'Set period',
        unload: 'Unload',
        types: {
            wiring: 'Report on goods in motion by delivery orders',
        },
    },

    main: {
        test: {
            title: 'Test order',
            lead: 'Working with test orders',
        },

        orderChangeStatus: {
            title: 'Changing the order status',
            lead: 'Go to change the order status',
        },

        externalServices: {
            title: 'Enabling services',
            lead: 'Enabling and disabling third-party services',
            modal: 'Enable/Disable services',
        },

        roles: {
            title: 'Configuring Roles',
            lead: 'Configuring Role Settings',
        },

        tracknumSearch: {
            title: 'Search for orders',
            lead: 'Search for orders by track number',
        },

        mailing: {
            title: 'Mailing lists',
            lead: 'Administration of mailing list recipients',
        },

        events: {
            title: 'Event Management',
            lead: 'Viewing failed events and their further restart or cancellation',
        },

        sap: {
            title: 'SAP',
            lead: 'Sending requests to SAP',
        },

        acceptanceActs: {
            title: 'APP',
            lead: 'History of acceptance and transfer certificates',
        },

        check: {
            title: 'Bills',
            lead: 'Sending receipts, View checks',
        },

        distribution: {
            title: 'Order distribution',
            lead: 'Order distribution',
        },

        reports: {
            title: 'Reports',
            lead: 'Generating reports',
        },

        ui: {
            title: 'Interface customization',
            lead: 'Adjusting the display of blocks',
            priority: 'Page Orders',
            expired: 'Priority',
            expiredTitle: 'Categories',
            priorityTitle: 'Category Management',
            save: 'Save Changes',
            cancel: 'Cancel',
            alert: 'On this page, you can set the scheduled time for completing tasks with the types "To Formation" and "To Formation for Delivery" in minutes. You can enter a value between {min} and {max} minutes.\nWARNING! The settings will only be applied to new orders created after saving the changes!',
            modal: {
                save: {
                    title: 'Attention!',
                    text: 'Save Changes?',
                },
                cancel: {
                    title: 'Attention!',
                    text: 'Cancel changes?',
                },
            },
        },
        reference: {
            title: 'Setting up help links',
            lead: 'CRM section compliance settings',
            alert: 'On this page, you need to match the CRM sections and links to reference resources, which will be navigated when you click on the Help button',
            fields: {
                section: 'Section',
                link: 'Section link',
                path: 'Link',
            },
            modal: {
                title: 'Attention!',
                text: 'Confirm editing reference links. Changes cannot be rolled back!',
            },
        },

        alerts: {
            title: 'Alerts',
            lead: 'List of orders requiring attention',
        },
    },

    orderChange: {
        placeholder: 'Order number',
        invalidFeedback: 'Order not found!',
        title: 'Order № {order} from {date}',
        p: 'Status:',
        label: 'New status',
        button: 'Change Status',
        search: 'Search',
        changeStatus: 'Status changed successfully',
        factory: 'Factory',
        warehouse: 'Warehouse',
        hintFieldLength: 'Поле состоит из 3-4 символов',
        hintFieldIsNotFilled: 'Поле не заполнено',
    },
    distribution: {
        enable: 'Enable order distribution functionality',
        overloadPfm: 'Consider PFM loading',
        limit: 'Loading limit of orders in the status "To formation" of the warehouse C001',
        percent: 'Choose PFM, which have at least ...% of items from the order in stock',
        percentPlaceholder: 'Limit',
        pfmTitle: 'PFM for order distribution',
        addPfm: 'Add PFM',
        ifPfm: 'If no PFM is suitable, then',
        save: 'Save',
        moscow: 'C001',
        otherPfm: 'Other Stores',
        basePfm: 'Base Stores',
        selectPfm: 'Select Store',
        pfmControlTitle: 'Manage base Stores',
        addBasePfm: 'Add base Store',
        incorrectPfm: "Store's wrong number",
        list: {
            enable: 'On | Off',
            warning: 'The PFM number is already in the table!',
            comment: 'minimum - 3, maximum - 4 characters',
            title: 'Confirm PFM deletion',
            save: 'Save',
            'delete': 'Delete',
            cancel: 'Cancel',
            pfm: 'PFM',
            buttons: 'Manage',
            limit: 'Limit',
        },
    },
    externalServiceAlert: 'Attention! Disabling services can adversely affect the operation of the system.',
    testOrderAlert: 'Attention! Changing the payment status of a test order can result in real checks and transactions being generated',

    tracknumSearch: {
        invalidFeedback: 'No orders found for the entered track number',
        title: 'Order №{orderId}',
        orderId: 'Order №',
        deliveryTrack: 'Delivery track number',
        deliveryService: 'Delivery service',
        orderStatus: 'Order status',
        deliveryStatus: 'Delivery status',
        orderCard: 'Order card',
        search: 'Search',
        rpo: {
            title: 'Russian Post ID',
            subtitle: 'Get Russian Post track numbers by orders numbers',
            fileNotSelected: 'File not selected',
            chooseFile: 'Select file',
            downloadTemplate: 'Download template {link} to fill out',
            cvsFile: '.csv-file',
            download: 'Download',
            fileProcessedSuccessfully: 'The file has been successfully processed, click the "Download" button',
            reset: 'Reset',
        },
    },
};